import { useEffect, useState } from "react";
import DonutChart from "./DonutChart";
import UnsignedForm from "./UnsingedForm";
import { useAppContext } from "../../context/app.context";
import { Constant, SECTION_NAMES } from "../../helper/constant";
import { Images } from "../../helper/images";
import { NavigationButton } from "../intro/objective";
import { useNavigate } from "react-router-dom";
import { DisabledNavLink } from "../../component/sidemenu";

const AIValue = () => {
    const { revenueReport } = useAppContext();
    const navigate = useNavigate();

    const getMaterialCostIncrease = () =>
        revenueReport.before.inventory_benefit -
        revenueReport.after.inventory_benefit;

    const getRevenueIncrease = () =>
        revenueReport.after.revenue_increase -
        revenueReport.before.revenue_increase;

    const getManpowerBenefit = () =>
        revenueReport.before.manpower_benefit -
        revenueReport.after.manpower_benefit;

    const getOverAllExpenses = () =>
        Number(revenueReport.before.revenue_increase) +
        Number(revenueReport.before.manpower_benefit) +
        Number(revenueReport.before.inventory_benefit);

    const getAdditionalProfit = () => {
        return (
            (getRevenueIncrease() +
                getManpowerBenefit() +
                getMaterialCostIncrease()) *
            Constant.Million
        );
    };

    const calculatePercentage = (value, base) => {
        return (Number(value) / Number(base)) * 100;
    };


    const renderChart = () => {
        if (revenueReport) {
            const additionalProfit = getAdditionalProfit();
            const percentage = calculatePercentage(
                additionalProfit,
                getOverAllExpenses() * Constant.Million
            ).toFixed(2);
            return (
                <DonutChart
                    values={[getRevenueIncrease() * Constant.Million, getMaterialCostIncrease() * Constant.Million, getManpowerBenefit() * Constant.Million]}
                    primaryText={additionalProfit}
                    secondaryText={percentage} />
            )
        }
        return <img src={Images.aiValueDefault} className="ai-value-default" alt="ai-value" />
    }
    const render = () => {
        return (
            <div className="row d-flex align-items-center mx-5">
                <div className="col-sm-4">
                    <UnsignedForm />
                </div>
                <div className="col-sm-8">
                    {renderChart()}
                </div>
            </div>
        )
    }
    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className=" text-blue h4 mb-3 mb-0">{SECTION_NAMES.AI_VALUE}</h3>
                <div className="d-flex align-items-center gap-4">
                    <DisabledNavLink to='/gap-analysis'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.GAP_ANALYSIS}</p></DisabledNavLink>
                    <DisabledNavLink to='/strategic-impact'><p className="m-0 p-0">{SECTION_NAMES.STRATEGIC_IMPLICATIONS}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                </div>
            </div>
            {render()}
            {/* <div style={{ textAlign: "center" }}>
                <button className="slick-arrow slick-prev slick-prev-page" onClick={() => navigate('/gap-analysis')}></button>
                <button className={`slick-arrow slick-next slick-next-page`} onClick={() => navigate('/strategic-impact')}></button>
            </div> */}
        </>
    );
};

export default AIValue;
